<script>
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import {mapActions, mapState} from "vuex";
import FormModal from "@/driver/pages/masters/recycle_disposal_methods/_FormModal.vue";
import ShowModal from "@/driver/pages/masters/recycle_disposal_methods/_ShowModal.vue";
import {enable} from "core-js/internals/internal-metadata";
import DownloadMixin from '../../../../mixins/download-mixin'

export default {
  name: "DriverMasterRecycleDisposalMethods",
  components: {
    FormModal,
    ShowModal,
    CustomPagination
  },
  mixins: [DownloadMixin],
  data () {
    return {
      conditions: {
        name: null,
        primary_after_disposal_method_id: null,
        after_disposal_method_ids: [],
        without_invisible: true
      },
      page: 1,
      perPage: 50,
      totalVisible: 7,
      headers: [
        { value: 'code', text: 'コード' },
        { value: 'name', text: '処分方法名' },
        { value: 'primary_after_disposal_method_name', text: '主たる処分方法' },
        { value: 'after_disposal_method_names', text: '処分１/処分２/処分３/処分４' },
        { value: 'sort_priority', text: '表示順', align: 'right' },
        { value: 'invisible', text: '非表示', align: 'center' },
        { value: 'updated_at', text: 'データ更新日時' },
        { value: 'editable', text: '詳細・編集', align: 'end', sortable: false },
      ],
      items: [],
      enableFormModal: false,
      enableShowModal: false,
      targetId: null,
      afterRecycleMethods: [],
    }
  },
  computed: {
    ...mapState('DriverMasterRecycleDisposalMethod',
      [
        'pagination',
        'condition'
      ]
    )
  },
  watch: {},
  created() {

    if (this.$route.params.resetCondition) {
      this.resetState();
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination();
    }

    Object.assign(this.conditions, this.condition)

    this.fetchAfterRecycleMethods().then((content) => {
      this.afterRecycleMethods = content.after_recycle_methods;
    });

    this.search();
  },
  methods: {
    ...mapActions('DriverMasterRecycleDisposalMethod', {
      fetchRecycleDisposalMethods: 'index',
      resetState: "resetState",
      resetPagination: "resetPagination",
    }),
    ...mapActions("DriverMasterSearchAfterRecycleMethod", {
      fetchAfterRecycleMethods: "index"
    }),
    nameClearCallback () {
      this.conditions.name = null;
      this.searchButtonClickEvent();
    },
    /**
     * 検索ボタンクリックイベント
     */
    searchButtonClickEvent() {
      this.page = 1;
      this.search();
    },
    exportCsvButtonClickEvent () {
      let params = this.buildParam("csv");
      this.fetchRecycleDisposalMethods(params).then((content) => {
        this.downloadCsv(content, "処分方法")
      })
    },
    importCsvButtonClickEvent () {
      this.$router.push({ name: 'DriverMasterRecycleDisposalMethodsCsvImport' })
    },

    addButtonClickEvent () {
      this.targetId = null;
      this.enableFormModal = true;
    },
    showButtonClickEvent (item) {
      this.targetId = item.id;
      this.enableShowModal = true;
    },
    editButtonClickEvent (item) {
      this.targetId = item.id;
      this.enableFormModal = true;
    },

    pageChangeCallback (page) {
      this.page = page;
      this.search();
    },

    perPageChangeCallback (perPage) {
      this.perPage = perPage;
      this.page = 1;
      this.search();
    },

    /**
     * 一覧検索処理
     */
    search () {
      const params = {
        name: this.conditions.name,
        primary_after_disposal_method_id: this.conditions.primary_after_disposal_method_id,
        after_disposal_method_ids: this.conditions.after_disposal_method_ids,
        without_invisible: this.conditions.without_invisible,
        page: this.page,
        limit: this.perPage
      }

      this.fetchRecycleDisposalMethods(params).then((content) => {
        this.items = content.recycle_disposal_methods
      })
    },
    /**
     * 追加・詳細・編集モーダル 閉じるコールバック
     */
    closeModalCallback () {
      this.enableFormModal = false;
      this.enableShowModal = false;
    },
    /**
     * 追加・編集モーダル 登録完了コールバック
     */
    registerCallback () {
      this.page = 1;
      this.search();
      this.closeModalCallback();
    },
    /**
     * 詳細モーダルから編集モーダルへ遷移コールバック
     */
    editCallback () {
      this.enableShowModal = false;
      this.enableFormModal = true;
    },
    buildParam(format) {
      return {
        name: this.conditions.name,
        primary_after_disposal_method_id: this.conditions.primary_after_disposal_method_id,
        after_disposal_method_ids: this.conditions.after_disposal_method_ids,
        without_invisible: this.conditions.without_invisible,
        page: this.page,
        limit: this.perPage,
        format: format,
      }
    }
  }
}
</script>

<template>
  <v-container fluid>
    <h2 class="mb-5">
      <v-icon class="mr-2">mdi-clipboard-flow-outline</v-icon>
      処分方法
    </h2>
    <v-expansion-panels accordion>
      <v-expansion-panel>
        <v-expansion-panel-header class="panel-header-color panel-selectable">
          <strong>
            <v-icon class="panel-header-color">
              mdi-magnify
            </v-icon>
            &nbsp;条件を指定して検索
          </strong>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="conditions.name"
                    dense
                    hide-details
                    label="処分方法名"
                    clearable
                    outlined
                    persistent-placeholder
                    placeholder="部分一致で検索"
                    rounded
                    @blur="searchButtonClickEvent"
                    @click:clear="nameClearCallback"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="conditions.primary_after_disposal_method_id"
                    :items="afterRecycleMethods"
                    clearable
                    dense
                    hide-details
                    label="主たる処分方法"
                    outlined
                    rounded
                    persistent-placeholder
                    @change="searchButtonClickEvent"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="conditions.after_disposal_method_ids"
                    :items="afterRecycleMethods"
                    clearable
                    dense
                    hide-details
                    label="処分方法"
                    outlined
                    rounded
                    multiple
                    persistent-placeholder
                    @change="searchButtonClickEvent"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-checkbox
                    v-model="conditions.without_invisible"
                    label="非表示を表示しない"
                    dense
                    hide-details="auto"
                    @change="searchButtonClickEvent"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click="searchButtonClickEvent">
                <v-icon>mdi-magnify</v-icon>&nbsp;検索
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-row class="mt-1">
      <v-col class="text-right">
        <v-btn color="info" @click="exportCsvButtonClickEvent">
          <v-icon>mdi-file-download-outline</v-icon>&nbsp;CSV出力
        </v-btn>
        &nbsp;
        <v-btn color="info" @click="importCsvButtonClickEvent">
          <v-icon>mdi-file-upload-outline</v-icon>&nbsp;CSV取込
        </v-btn>
        &nbsp;
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          新規追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="pageChangeCallback"
          @perPageChanged="perPageChangeCallback"
        />
      </v-col>
    </v-row>

    <v-sheet class="mt-5 mb-5" rounded>
      <v-data-table
        :headers="headers"
        :items="items"
        disable-pagination
        :items-per-page="-1"
        disable-sort
        hide-default-footer
      >
        <template v-slot:[`item.invisible`]="{ item }">
          <span v-if="item.invisible">非表示</span>
        </template>

        <template v-slot:[`item.updated_at`]="{ item }">
          {{ item.updated_at | unix_datetime_format }}
        </template>

        <template v-slot:[`item.editable`]="{ item }">
          <v-btn
            :icon="$vuetify.breakpoint.mdAndUp"
            :text="$vuetify.breakpoint.smAndDown"
            :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2' : null}`"
            @click="showButtonClickEvent(item)"
          >
            <v-icon v-if="$vuetify.breakpoint.mdAndUp">
              mdi-file-document-outline
            </v-icon>
            <span v-else>詳細</span>
          </v-btn>
          <v-btn
            :icon="$vuetify.breakpoint.mdAndUp"
            :text="$vuetify.breakpoint.smAndDown"
            :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2' : null}`"
            @click="editButtonClickEvent(item)"
          >
            <v-icon v-if="$vuetify.breakpoint.mdAndUp">
              mdi-note-edit
            </v-icon>
            <span v-else>編集</span>
          </v-btn>
        </template>
      </v-data-table>
    </v-sheet>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="pageChangeCallback"
          @perPageChanged="perPageChangeCallback"
        />
      </v-col>
    </v-row>
    <!-- ページャ -->

    <form-modal
      :after-recycle-methods="afterRecycleMethods"
      :enable-dialog="enableFormModal"
      :target-id="targetId"
      @close="closeModalCallback"
      @register="registerCallback"
    />
    <show-modal
      :after-recycle-methods="afterRecycleMethods"
      :enable-dialog="enableShowModal"
      :target-id="targetId"
      @close="closeModalCallback"
      @edit="editCallback"
      @register="registerCallback"
    />
  </v-container>
</template>

<style scoped lang="scss">

</style>
